import { Badge, Icon, Text } from '@kognitos/lattice';
import { V1AutomationStage } from '@/generated/hooks/jeeves/models';
import { useTranslation } from 'react-i18next';
import { EVersionHistoryItemState } from './types';

/**
 * Badge type variants for version history items.
 */
export interface IVersionBadgeProps {
  stage: V1AutomationStage;
  state: EVersionHistoryItemState;
}

/**
 * Version badge component that shows draft or published status.
 *
 * @param stage - The automation stage (draft or published)
 * @param state - The visual state (default or selected)
 *
 * TODO: Change badge component to have rounded-sm. This badge should be rounded-sm, but currently is rounded-md.
 */
export function VersionHistoryBadge({
  stage,
  state = EVersionHistoryItemState.DEFAULT,
}: IVersionBadgeProps) {
  const { t } = useTranslation('automation');

  const isDraft = stage === V1AutomationStage.AUTOMATION_STAGE_DRAFT;

  return (
    <Badge
      variant={
        state === EVersionHistoryItemState.SELECTED ? 'secondary' : 'outline'
      }
      className="transition-all" // allows badge to transition between states at the same time as the parent component
    >
      <Icon
        type={
          stage === V1AutomationStage.AUTOMATION_STAGE_DRAFT ? 'Disc' : 'Rocket'
        }
        size="xs"
      />
      <Text weight="semibold" className="text-xs">
        {isDraft
          ? t('automation.versionHistory.item.state.draft')
          : t('automation.versionHistory.item.state.published')}
      </Text>
    </Badge>
  );
}
